import React from "react";
import "./PublishingHeroSection.css";
import { useNavigate } from "react-router-dom";

import heroImage from "../../Assets/images/amplehouse.jpeg";
import eventFlyer from "../../Assets/images/StoryFest.jpeg"; 

export default function PublishingHeroSection() {

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/contact-us");
  };

  return (

    <section
      className="publishing-hero-section"
      style={{
        backgroundImage: `
          linear-gradient(
            rgba(15, 10, 8, 0.78),
            rgba(15, 10, 8, 0.84)
          ),
          url(${heroImage})
        `
      }}
    >

      {/* Content */}
      <div className="publishing-hero-content">

        {/* LEFT CONTENT */}
        <div className="publishing-hero-left">

          <h1>
            Ample Publications
          </h1>

          <p className="publishing-description">
            Turn ideas into books and intellectual property.
          </p>

          <p className="publishing-description">
            Partner with Ample House to go from concept to published book and beyond.
          </p>

          <button
            className="publishing-btn"
            onClick={handleNavigate}
          >
            Start Your Publishing Journey
          </button>

        </div>

        {/* RIGHT IMAGE - EVENT FLYER */}
        <div className="publishing-hero-right">

          <div className="event-flyer-wrapper">

            <div className="flyer-container">
              <div className="coming-soon-badge">Coming Soon</div>
              <img
                src={eventFlyer}
                alt="Event Flyer"
                className="event-flyer-image"
              />
            </div>

            {/* Flyer Details */}
            <div className="flyer-details">
              <div className="detail-item">
                <span className="detail-icon">📅</span>
                <span>Date: 11th - 13th December 2026</span>
              </div>
              <div className="detail-item">
                <span className="detail-icon">📍</span>
                <span>Location: Accra, Ghana</span>
              </div>
            </div>

          </div>

        </div>

      </div>

    </section>

  );
}